var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"bottom-remarks"},_vm._l((_vm.lang === 'zh' ? 8 : 10),function(i){return _c('li',{key:i,staticClass:"bottom-remarks-item"},[_vm._v(" "+_vm._s(_vm.$t(("bottom-remarks-item-" + i)))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }